<script setup>
defineProps({
    modelValue: { type: String, default: "" },
    placeholder: { type: String, default: "" },
    inputClass: { type: String, default: null },
    label: { type: String, default: null },
    error: { type: String, default: null },
    autofocus: { type: Boolean, default: false },
});

defineEmits(["update:modelValue"]);
</script>

<template>
    <div class="flex flex-col gap-3">
        <p v-if="label" class="body-sm leading-none font-bold uppercase faded-text">
            {{ label }}
        </p>
        <div
            class="relative isolate before:absolute before:top-0 before:left-0 before:size-1.5 before:bg-yellow-400"
        >
            <input
                :value="modelValue"
                type="text"
                :placeholder
                :autofocus
                :class="['body-md border-marine-500 min-h-14 border bg-transparent px-4 py-3 leading-none uppercase placeholder:text-white placeholder:opacity-50', error && 'border-red-400', inputClass]"
                @input="$emit('update:modelValue', $event.target.value)"
            />
        </div>
        <p v-if="error" class="body-sm text-red-400 leading-none">{{ error }}</p>
    </div>
</template>
